import { render, staticRenderFns } from "./TableauDesTypesDeDocuments.vue?vue&type=template&id=763aabba&"
import script from "./TableauDesTypesDeDocuments.vue?vue&type=script&lang=js&"
export * from "./TableauDesTypesDeDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports